<template>
  <div
    class="collapsible"
    :class="{
      'collapsible--collapsed': !isOpen
    }"
  >
    <div
      class="collapsible__trigger"
      @click="toggle"
    >
      <slot
        name="trigger"
        :isOpen="isOpen"
      ></slot>
    </div>
    <div
      class="collapsible__content"
			ref="content"
    >
      <div class="collapsible__content-wrapper">
        <slot
          :isOpen="isOpen"
          :open="open"
          :close="close"
          :toggle="toggle"
        ></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		initialOpen: {
			type: Boolean,
			default: true,
		}
	},
	data() {
		return {
			isOpen: this.initialOpen,
		};
	},
	methods: {
		toggle() {
			return new Promise(resolve => {
				this.$refs.content.addEventListener('transitionend', e => {
					this.isOpen
						? this.$emit('opened')
						: this.$emit('closed')
					this.$emit('toggled', this.isOpen)
					resolve()
				}, { once: true });

				setTimeout(() => {
					this.isOpen = !this.isOpen;
					this.$emit('toggle', this.isOpen);
					this.isOpen
						? this.$emit('open')
						: this.$emit('close')
				}, 1);
			})
    },
    open() {
      if (!this.isOpen) {
        return this.toggle();
      }
    },
    close() {
      if (this.isOpen) {
        return this.toggle();
      }
    },
	}
}
</script>
